export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["À"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Montant"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transférer"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transfert entre comptes personnels"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transferts dans le portefeuille"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Les comptes expéditeur et destinataire doivent être différents"])}
}